import type { WorkflowRule } from '@/pages/ats-job-creation/tabs/interview-plan/stage/automation/api/workflowRule.types';

// The FE undo popup only owns automation whose FIRST step runs immediately (it
// shows the 15s undo, then calls `/trigger`). A first step configured "with a
// delay" is scheduled and fired by the BE on its own clock, so the move flow
// must NOT enqueue/trigger it.
//
// The first step is the lowest-position action; a position-1 action triggers
// off stage entry, which is immediate exactly when its delay is 0. Returns
// false when the rule has no actions (nothing to run now).
export const isImmediateFirstStep = (rule: WorkflowRule): boolean => {
  const first = [...(rule.actions ?? [])].sort(
    (a, b) => a.position - b.position
  )[0];
  if (!first) return false;
  return (first.delay_seconds ?? 0) === 0;
};
